import { FEATURES } from '../../../contexts/FeatureContext';

/** Features shown in Organization Settings and League Settings, in display order. */
export const FEATURE_DEFINITIONS = [
  {
    key: FEATURES.SPARES,
    label: 'Spares',
    description: 'Spare pools, spare availability, spare reminders and emails, spare registration positions and the Spares chat.',
    offWarning: 'Spare pages, reminders, emails, registration positions and the Spares chat will be hidden, and any scheduled spare emails will be cancelled. Spare members and history are kept, so you can turn spares back on later.',
  },
];
